// This project's ~90 admin GraphQL operations used to live in one 1700+ line
// file. They're now split by entity in this folder; every existing
// `import { X } from ".../graphql/admin-requests"` keeps working unchanged.

export * from "./activities";
export * from "./classroom-activities";
export * from "./group-activities";
export * from "./groups";
export * from "./grades";
export * from "./classrooms";
export * from "./periods";
export * from "./places";
export * from "./users";
export * from "./process-calendar";
